import uploader from "../api/sale/upload/index"

export const uploadImgWithUidByFileapiPromise = (fileData, agency_uid) => {
  return new Promise((resolve, reject) => {
    uploader
      .uploadImg({
        operation: "upload",
        agency_uid,
        files: fileData,
      })
      .then(
        (data) => {
          // 上传成功
          if (data.successFiles.length > 0) {
            resolve(data.successFiles[0])
          }

          // 上传失败
          if (data.failedFiles.length > 0) {
            reject(data.failedFiles)
          }
        },
        (e) => {
          reject(e)
        }
      )
  })
}

export const formatDeprecQualification = (others) => {
  const res = []
  for (const i in others) {
    if (others[i].images && others[i].images[0] && others[i].images[0].image_url) {
      res.push({
        url: others[i].images[0].image_url,
        id: "deprecated_" + i,
      })
    }
  }
  return res
}

export default {
  uploadImgWithUidByFileapiPromise,
  formatDeprecQualification,
}
